import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';
import { PURCHASES_PATHS } from './constants';

/** Les routes enfant React Router sont relatives : on retire le slash de tête. */
const toSegment = (path: string): string => path.replace(/^\//, '');

export const purchasesRoutes: RouteObject[] = [
  {
    path: toSegment(PURCHASES_PATHS.root),
    Component: Outlet,
    handle: { context: CONTEXTS.PURCHASES, title: 'Boutique' },
  },
  {
    path: toSegment(PURCHASES_PATHS.complete),
    Component: Outlet,
    handle: { context: CONTEXTS.PURCHASES_COMPLETE, title: 'Test complet' },
  },
  {
    path: toSegment(PURCHASES_PATHS.packEval),
    Component: Outlet,
    handle: { context: CONTEXTS.PURCHASES_PACK_EVAL, title: "Pack d'éval" },
  },
  {
    path: toSegment(PURCHASES_PATHS.history),
    Component: Outlet,
    handle: { context: CONTEXTS.PURCHASES_HISTORY, title: 'Mes achats' },
  },
  {
    path: toSegment(PURCHASES_PATHS.paymentSuccess),
    Component: Outlet,
    handle: { context: CONTEXTS.PAYMENT_SUCCESS, title: 'Paiement confirmé' },
  },
  {
    path: toSegment(PURCHASES_PATHS.paymentCancel),
    Component: Outlet,
    handle: { context: CONTEXTS.PAYMENT_CANCEL, title: 'Paiement annulé' },
  },
];
